<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!---->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-map-marker-alt" id="ico"></i>
		<h1 style="display:inline-block;">Ubicación</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<mat-card>
	<div class="map-content" id="map-content">
		<div id="map-marker" class="map-marker ">
		</div>
	</div>
	<!--<button class="btnPopup mt-3 offset-md-9" (click)="verStreetView();"><i style="color:#01a7cd;"
				class="fal fa-street-view"></i>&nbsp;
			Street
			View</button>-->
	<!--<div [hidden]="isStreetView">
		<div [hidden]="!isAvailable" id="pano" style="width: 100%; height: 400px;"></div>
		<div *ngIf="!isAvailable">No se encuentra disponible la función street view en esta zona</div>
		<button [hidden]="isStreetView" class="btnPopup mt-3 offset-md-9" (click)="verMapa();"><i style="color:#01a7cd;"
				class="fal fa-street-view"></i>&nbsp;
			Mapa</button>
	</div>-->
</mat-card>
